document.addEventListener('DOMContentLoaded', function () {
  function termAndConditions() {
    setTimeout(() => {
      const submitButton = document.querySelector('.buy-buttons button[type="submit"]');
      const termsCheckbox = document.querySelector('.terms-and-conditions-checkbox');
      
      if (!submitButton || !termsCheckbox) {
        return; // Exit if elements don't exist
      }

      const termsChecked = termsCheckbox.checked;

      if (!termsChecked) {
        submitButton.setAttribute('name', 'checkout-terms');
        submitButton.title = 'Du skal acceptere vilkårene og betingelserne for at kunne fortsætte';
      }

      termsCheckbox.addEventListener('change', function () {
        const termsChecked = this.checked;

        submitButton.setAttribute('name', termsChecked ? 'checkout' : 'checkout-terms');
        submitButton.title = termsChecked ? 'Du skal acceptere vilkårene og betingelserne for at kunne fortsætte' : 'Gå til betaling';
      });
    }, 1000);
  }

  termAndConditions();
  document.addEventListener('cart:change', termAndConditions);
});

document.addEventListener('DOMContentLoaded', function () {
  // Add a special CSS class when the cart-icon is clicked 
  const cartIcon = document.querySelector("#cart-icon");
  if (cartIcon) {
    cartIcon.addEventListener("click", function(){
      document.body.classList.toggle("js-show-ajax-cart");
      // Close all quick buy drawers when cart opens
      if (document.body.classList.contains("js-show-ajax-cart")) {
        closeAllQuickBuyDrawers();
      }
    });
  }
});

// Close cart when clicking on the overlay
function closeCart() {
  document.body.classList.toggle("js-show-ajax-cart");
}

// Function to close all quick buy drawers
function closeAllQuickBuyDrawers() {
  const quickBuyDrawers = document.querySelectorAll('quick-buy-drawer[open]');
  quickBuyDrawers.forEach(drawer => {
    drawer.removeAttribute('open');
  });
}

// Make functions available globally
window.closeCart = closeCart;
window.closeAllQuickBuyDrawers = closeAllQuickBuyDrawers;

// Watch for cart opening and close quick buy drawers automatically
document.addEventListener('DOMContentLoaded', function() {
  // Use MutationObserver to watch for class changes on body
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (document.body.classList.contains('js-show-ajax-cart')) {
          closeAllQuickBuyDrawers();
        }
      }
    });
  });
  
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });
});

// Listen for the "liquid-ajax-cart:request-end" event which is fired
// after a Shopify Cart API Ajax request is performed
document.addEventListener('liquid-ajax-cart:request-end', event => {
  const {requestState} = event.detail;

  // If the "add to cart" request is successful
  if (requestState.requestType === 'add' && requestState.responseData?.ok) {
    // Add the CSS class to the "body" tag
    document.body.classList.add('js-show-ajax-cart');
    
    // Close all quick buy drawers when cart opens
    closeAllQuickBuyDrawers();

    // Check if js-ajax-cart-empty is not present on the HTML tag
    const cartRecommendations = document.querySelector("#shopify-section-cart-recomendations");
    if (!document.documentElement.classList.contains("js-ajax-cart-empty") && cartRecommendations) {
      setTimeout(function(){
        cartRecommendations.classList.add("cart-recom-slidein");
      }, 500);
    } else if (cartRecommendations) {
      cartRecommendations.classList.remove("cart-recom-slidein");
    }
  }
});

// terms and conditions with popup
document.addEventListener('DOMContentLoaded', function() {
  let modal = document.getElementById("terms-modal");
  let acceptButton = document.getElementById("accept-terms");

  if (!modal || !acceptButton) return; // Exit if elements don't exist

  document.body.addEventListener('click', function(event) {
    let target = event.target;
    let nameAttr = target.getAttribute('name');
    
    if (nameAttr === 'checkout' || nameAttr === 'goto_pp' || nameAttr === 'goto_gc') {
      let agreeCheckbox = document.getElementById('agree');
    
      if (agreeCheckbox && agreeCheckbox.checked) {
        target.form.submit();
      } else {
        modal.style.display = "block";
        event.preventDefault();
      }
    }
  });

  acceptButton.onclick = function() {
    modal.style.display = "none";
    var agreeCheckbox = document.getElementById('agree');
    if (agreeCheckbox) {
      agreeCheckbox.checked = true;
    }

    // Redirect to the checkout page
    window.location.href = '/checkout';
  }

  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }
});

// cart instructions dropdown
function toggleCartInstructions() {
  var dropdown = document.getElementById('cartInstructionDropdown');
  var arrow = document.getElementById('arrow');
  if (dropdown && arrow) {
    if (dropdown.classList.contains('hidden')) {
        dropdown.classList.remove('hidden');
        arrow.classList.remove('arrow-down');
        arrow.classList.add('arrow-up');
    } else {
        dropdown.classList.add('hidden');
        arrow.classList.remove('arrow-up');
        arrow.classList.add('arrow-down');
    }
  }
}

// PRODUCT ITEM 
document.addEventListener("DOMContentLoaded", function () {
  const colorContainer = document.querySelector(".color_container");
  const productItems = document.querySelectorAll(".Product-item");

  if (colorContainer) {
    const colorLinks = colorContainer.querySelectorAll(".color_link");
    const activeColor = colorContainer.querySelector(".active_color");
    const activeColorName = activeColor ? activeColor.querySelector(".color_name") : null;

    if (activeColorName) {
      colorLinks.forEach(link => {
        if (link !== activeColor) {
          link.addEventListener("mouseenter", () => {
            activeColorName.classList.add("hidden");
          }); 

          link.addEventListener("mouseleave", () => {
            activeColorName.classList.remove("hidden");
          });
        }
      });
    }
  }

  if (productItems.length > 0) {
    productItems.forEach(item => {
      const colorLinks = item.querySelectorAll(".color_link");
      const activeColorItem = item.querySelector(".active_color");
      const activeColorNameItem = activeColorItem ? activeColorItem.querySelector(".color_name") : null;

      colorLinks.forEach(link => {
        const linkColorName = link.querySelector(".color_name");

        if (linkColorName) {
          link.addEventListener("mouseenter", () => {
            if (activeColorNameItem) {
              activeColorNameItem.classList.add("hidden");
            }

            if (link !== activeColorItem) {
              linkColorName.classList.remove("hidden");
            }
          });

          link.addEventListener("mouseleave", () => {
            if (activeColorNameItem) {
              activeColorNameItem.classList.remove("hidden");
            }

            if (link !== activeColorItem) {
              linkColorName.classList.add("hidden");
            }
          });
        }
      });
    });
  }

  document.addEventListener('liquid-ajax-cart:request-end', event => {
    const {requestState} = event.detail;
  
    // If the "add to cart" request is successful
    if (requestState.requestType === 'add' && requestState.responseData?.ok) {
  
      // Add the CSS class to the "body" tag
      document.body.classList.add('js-show-ajax-cart');
      closeAllQuickBuyDrawers();
    }
  });
});

// Unified Preorder System - Global Implementation
window.UnifiedPreorderSystem = {
  pending: false,
  pendingRequestState: null,
  cancelled: false,
  initialized: false,
  
  init: function() {
    if (this.initialized) return;
    

    // Intercept ALL liquid-ajax-cart requests with highest priority
    document.addEventListener('liquid-ajax-cart:request-start', (event) => {
      this.handleCartRequest(event);
    }, { capture: true });

    // ALSO intercept all form submissions that might not go through liquid-ajax-cart
    document.addEventListener('submit', (event) => {
      this.handleFormSubmission(event);
    }, { capture: true });

    this.initialized = true;
  },

  handleFormSubmission: function(event) {
    const form = event.target;
    
    // Only handle product forms
    if (!form.matches('form[action*="/cart/add"]') && 
        form.getAttribute('is') !== 'product-form' &&
        !form.closest('ajax-cart-product-form')) {
      return;
    }

    if (this.pending || this.cancelled) {
      return;
    }


    const formData = new FormData(form);
    const isAddingPreorder = formData.get('properties[_preorder]') === 'true';
    

    // ALWAYS prevent default first, then check asynchronously
    event.preventDefault();
    event.stopImmediatePropagation();

    // Get current cart state
    this.getCurrentCart().then(cart => {

      if (this.shouldShowPopup(isAddingPreorder, cart)) {
        
        const requestData = this.convertFormDataToObject(formData);
        this.showPopup(isAddingPreorder, requestData, 'form-submission');
      } else {
        // No conflict, submit the form normally
        this.submitFormNormally(form, formData);
      }
    });

    return false;
  },

  submitFormNormally: function(form, formData) {
    // Use liquid-ajax-cart if available, otherwise use native fetch
    if (window.liquidAjaxCart) {
      const requestData = this.convertFormDataToObject(formData);
      window.liquidAjaxCart.add(requestData, {
        lastCallback: (addRequestState) => {
          if (addRequestState.responseData && !addRequestState.responseData.message) {
            document.body.classList.add('js-show-ajax-cart');
            closeAllQuickBuyDrawers();
          } else {
            console.error('UnifiedPreorderSystem: Error adding product:', addRequestState.responseData?.message);
          }
        }
      });
    } else {
      // Fallback to native form submission
      fetch(form.action, {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        document.body.classList.add('js-show-ajax-cart');
        closeAllQuickBuyDrawers();
        // Optionally refresh cart UI here
      })
      .catch(error => {
        console.error('UnifiedPreorderSystem: Error in fallback submission:', error);
      });
    }
  },

  handleCartRequest: function(event) {
    const { requestState } = event.detail;


    // ONLY block ADD requests when popup should be shown
    if (requestState.requestType !== 'add' || this.pending || this.cancelled) {
      return;
    }

    const requestBody = requestState.requestBody;

    // Skip popup for auto-added free gift — it's not a real user action
    
if (
  this.isFreeGiftAdd(requestBody) ||
  this.isFreeShippingShadowAdd(requestBody)
) return;


    const isAddingPreorder = this.isPreorderProduct(requestBody);

    // Get current cart state
    this.getCurrentCart().then(cart => {

      if (this.shouldShowPopup(isAddingPreorder, cart)) {
        
        event.preventDefault();
        event.stopImmediatePropagation();
        requestState.info.cancel = true;

        const requestData = requestBody instanceof FormData ? 
          this.convertFormDataToObject(requestBody) : 
          JSON.parse(JSON.stringify(requestBody));

        this.showPopup(isAddingPreorder, requestData, 'ajax-request');
        return false;
      }
    });
  },

  getCurrentCart: function() {
    return new Promise((resolve) => {
      // Try liquid-ajax-cart first
      if (window.liquidAjaxCart && window.liquidAjaxCart.cart) {
        resolve(window.liquidAjaxCart.cart);
        return;
      }

      // Fallback to fetch cart
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => resolve(cart))
        .catch(() => resolve({ items: [] }));
    });
  },

  showPopup: function(isPreorder, requestData, sourceType = 'unknown') {
    console.log(`UnifiedPreorderSystem: Showing popup for ${sourceType}, isPreorder: ${isPreorder}`);

    const popupId = isPreorder ? 'unified-preorder-popup' : 'reverse-preorder-popup';
    const popup = document.getElementById(popupId);

    // If popup has no content (e.g. non-preorder page), skip popup and proceed with add
    const popupTitle = popup ? popup.querySelector('h3') : null;
    if (!popup || !popupTitle || !popupTitle.textContent.trim()) {
      console.log('UnifiedPreorderSystem: Popup has no content, proceeding without popup');
      this.pendingRequestState = { requestBody: requestData, isPreorder: isPreorder, sourceType: sourceType };
      this.confirmAction(!isPreorder);
      return;
    }

    this.pendingRequestState = {
      requestBody: requestData,
      isPreorder: isPreorder,
      sourceType: sourceType
    };

    popup.classList.remove('hidden');
    this.attachPopupListeners();
  },

  attachPopupListeners: function() {
    // Remove any existing listeners to prevent duplicates
    const confirmBtn = document.getElementById('unified-confirm-preorder');
    const cancelBtn = document.getElementById('unified-cancel-preorder');
    const reverseConfirmBtn = document.getElementById('reverse-confirm-regular');
    const reverseCancelBtn = document.getElementById('reverse-cancel-preorder');
    const popup = document.getElementById('unified-preorder-popup');
    const reversePopup = document.getElementById('reverse-preorder-popup');

    if (confirmBtn) confirmBtn.onclick = () => this.confirmAction(true);
    if (cancelBtn) cancelBtn.onclick = () => this.cancelAction();
    if (reverseConfirmBtn) reverseConfirmBtn.onclick = () => this.confirmAction(false);
    if (reverseCancelBtn) reverseCancelBtn.onclick = () => this.cancelAction();
    
    if (popup) {
      popup.onclick = (e) => {
        if (e.target === popup) this.cancelAction();
      };
    }
    
    if (reversePopup) {
      reversePopup.onclick = (e) => {
        if (e.target === reversePopup) this.cancelAction();
      };
    }
  },

  isPreorderProduct: function(requestBody) {
    
    if (requestBody instanceof FormData) {
      const isPreorderFromForm = requestBody.get('properties[_preorder]') === 'true';
      return isPreorderFromForm;
    } else if (requestBody.items) {
      const isPreorderFromItems = requestBody.items.some(item => 
        item.properties && item.properties._preorder === 'true'
      );
      return isPreorderFromItems;
    } else if (requestBody.properties) {
      const isPreorderFromProps = requestBody.properties._preorder === 'true';
      return isPreorderFromProps;
    }
    
    return false;
  },

  isFreeGiftAdd: function(requestBody) {
    if (requestBody instanceof FormData) {
      return requestBody.get('properties[_free_gift]') === 'auto-added';
    }
    if (requestBody.items) {
      return requestBody.items.some(item => item.properties?._free_gift === 'auto-added');
    }
    if (requestBody.properties) {
      return requestBody.properties._free_gift === 'auto-added';
    }
    return false;
  },

  isFreeShippingShadowAdd: function(requestBody) {
    if (requestBody instanceof FormData) {
      return requestBody.get('properties[_free_shipping_shadow]') === 'auto-added';
    }
    if (requestBody.items) {
      return requestBody.items.some(item =>
        item.properties?._free_shipping_shadow === 'auto-added'
      );
    }
    if (requestBody.properties) {
      return requestBody.properties._free_shipping_shadow === 'auto-added';
    }
    return false;
  },


  shouldShowPopup: function(isAddingPreorder, cart) {
    if (!cart || !cart.items || cart.items.length === 0) {
      return false;
    }

    // Filter out auto-added items (shadow product + free gift) — they don't count as "real" items for conflict detection
    const realItems = cart.items.filter(item =>
      item.properties?._autoadded_preorder !== 'Yes' &&
      item.properties?._free_gift !== 'auto-added' &&
      item.properties?._free_shipping_shadow !== 'auto-added'
    );

    if (realItems.length === 0) return false;

    // If adding preorder, show popup if cart has any regular (non-preorder) items
    if (isAddingPreorder) {
      const hasRegular = realItems.some(item => !item.properties || item.properties._preorder !== 'true');
      return hasRegular;
    } else {
      // If adding regular, show popup if cart has any preorder items
      const hasPreorder = realItems.some(item => item.properties && item.properties._preorder === 'true');
      return hasPreorder;
    }
  },

  convertFormDataToObject: function(formData) {
    const id = formData.get('id');
    const quantity = formData.get('quantity') || 1;
    const items = [{
      id: id ? parseInt(id) : undefined,
      quantity: parseInt(quantity),
      properties: {}
    }];
    for (let [key, value] of formData.entries()) {
      if (key.startsWith('properties[')) {
        const propKey = key.replace('properties[', '').replace(']', '');
        items[0].properties[propKey] = value;
      }
    }
    // Remove properties if empty
    if (Object.keys(items[0].properties).length === 0) {
      delete items[0].properties;
    }
    console.log('UnifiedPreorderSystem: convertFormDataToObject', { items });
    return { items: items };
  },

  confirmAction: function(isPreorder) {
    if (!this.pendingRequestState || this.pending) return;

    this.pending = true;

    this.addProductAfterClear(this.pendingRequestState.requestBody);
    this.hidePopup();
    this.resetState();
  },

  cancelAction: function() {
    console.log('UnifiedPreorderSystem: Cancel action');
    this.cancelled = true;
    this.hidePopup();
    
    setTimeout(() => {
      this.resetState();
    }, 100);
  },

  hidePopup: function() {
    const popup = document.getElementById('unified-preorder-popup');
    const reversePopup = document.getElementById('reverse-preorder-popup');
    if (popup) popup.classList.add('hidden');
    if (reversePopup) reversePopup.classList.add('hidden');
  },

  addProductAfterClear: function(requestData) {
    console.log('UnifiedPreorderSystem: addProductAfterClear requestData', requestData);
    // Defensive: ensure requestData is always in the correct format
    if (!requestData || !requestData.items || !Array.isArray(requestData.items) || !requestData.items[0] || !requestData.items[0].id) {
      console.error('UnifiedPreorderSystem: Invalid requestData for addProductAfterClear', requestData);
      this.pending = false;
      return;
    }
    if (window.liquidAjaxCart) {
      window.liquidAjaxCart.clear({}, {
        lastCallback: (clearRequestState) => {
          setTimeout(() => {
            window.liquidAjaxCart.add(requestData, {
              lastCallback: (addRequestState) => {
                this.pending = false;
                if (addRequestState.responseData && !addRequestState.responseData.message) {
                  document.body.classList.add('js-show-ajax-cart');
                  closeAllQuickBuyDrawers();
                } else {
                  console.error('UnifiedPreorderSystem: Error adding product:', addRequestState.responseData?.message);
                }
              }
            });
          }, 300);
        }
      });
    } else {
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      }).then(response => {
        if (response.ok) {
          setTimeout(() => {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(requestData)
            }).then(response => response.json())
            .then(data => {
              this.pending = false;
              document.body.classList.add('js-show-ajax-cart');
              closeAllQuickBuyDrawers();
            }).catch(error => {
              this.pending = false;
              console.error('UnifiedPreorderSystem: Error in fallback flow:', error);
            });
          }, 300);
          return;
        }
        throw new Error('Failed to clear cart');
      });
    }
  },

  resetState: function() {
    this.pending = false;
    this.pendingRequestState = null;
    this.cancelled = false;
  }
};


// --- Unified Preorder Mutation ---
function preorderMutation() {
  // Property to mark auto-added preorder companion
  const autoaddedProp = '_autoadded_preorder';
  // The variant ID to auto-add (from metafield, or detect from existing cart items)
  const preorderVariant = window.themeVariables?.settings?.preorderShadowVariantId
    || window.liquidAjaxCart?.cart?.items?.find(i => i.properties?.[autoaddedProp] === 'Yes')?.variant_id;
  if (!preorderVariant) return;
  // Current cart state
  const cart = window.liquidAjaxCart.cart;

  // Check if any item in cart has _preorder true
  const hasPreorder = cart.items.some(item => item.properties && item.properties._preorder === 'true');
  // Find if the auto-added variant is already in cart
  const autoAddedLineItem = cart.items.findIndex(lineItem => {
    return lineItem.variant_id === preorderVariant && lineItem.properties?.[autoaddedProp] === 'Yes';
  });

  if (hasPreorder) {
    // If _preorder is present and the variant is not in cart, add it
    if (autoAddedLineItem === -1) {
      return {
        requests: [
          {
            type: "add",
            body: {
              items: [{
                id: preorderVariant,
                quantity: 1,
                properties: { [autoaddedProp]: "Yes", _preorder: "true" }
              }]
            } 
          }
        ]
      };
    }
  } else {
    // If _preorder is not present but the variant is in cart, remove it
    if (autoAddedLineItem > -1) {
      return {
        requests: [
          {
            type: "change",
            body: {
              line: autoAddedLineItem + 1,
              quantity: 0
            }
          } 
        ]
      };
    }
  }
}


// Register the mutation with Liquid Ajax Cart reliably
function registerPreorderMutationWithRetry(retries = 10, delay = 300) {
  if (window.liquidAjaxCart && typeof window.liquidAjaxCart.conf === 'function') {
    window.liquidAjaxCart.conf('mutations', [preorderMutation, freeShippingShadowMutation]);
    console.log('preorderMutation + freeShippingShadowMutation registered with liquidAjaxCart');
    return;
  }
  if (retries > 0) {
    setTimeout(() => registerPreorderMutationWithRetry(retries - 1, delay), delay);
  } else {
    console.warn('cart mutations could not be registered: liquidAjaxCart not found');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  registerPreorderMutationWithRetry();
});

// Initialize the unified system when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  window.UnifiedPreorderSystem.init();
  console.log('Global UnifiedPreorderSystem initialized');
});

// Ensure shadow preorder is removed when it is the only item in the cart
document.addEventListener('liquid-ajax-cart:request-end', function(event) {
  // small delay to allow any internal state updates to settle
  setTimeout(() => {
    const autoaddedProp = '_autoadded_preorder';

    const getCart = () => {
      if (window.liquidAjaxCart && window.liquidAjaxCart.cart) return Promise.resolve(window.liquidAjaxCart.cart);
      return fetch('/cart.js').then(r => r.json()).catch(() => ({ items: [] }));
    };

    getCart().then(cart => {
      if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;

      // find shadow preorder line item that was auto-added
      const autoIndex = cart.items.findIndex(item => item.properties?.[autoaddedProp] === 'Yes');

      // If the autoadded preorder exists and is the only item in the cart, remove it
      if (autoIndex > -1 && cart.items.length === 1) {
        // Attempt to use liquidAjaxCart API if available
        if (window.liquidAjaxCart && typeof window.liquidAjaxCart.change === 'function') {
          window.liquidAjaxCart.change({ line: autoIndex + 1, quantity: 0 }, {
            lastCallback: () => {
              console.log('Removed autoadded preorder because it was the only item in the cart');
            }
          });
        } else {
          // Fallback to direct fetch change
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: autoIndex + 1, quantity: 0 })
          }).then(() => {
            console.log('Removed autoadded preorder (fallback) because it was the only item in the cart');
          }).catch(err => {
            console.error('Failed to remove autoadded preorder (fallback):', err);
          });
        }
      }
    });
  }, 50);
});


// --- Free Gift Auto-Add/Remove ---
function removeGiftIfPresent() {
  const cart = window.liquidAjaxCart?.cart;
  if (!cart || !Array.isArray(cart.items)) return;
  const idx = cart.items.findIndex(item => item.properties?._free_gift === 'auto-added');
  if (idx > -1) {
    window.liquidAjaxCart.change({ line: idx + 1, quantity: 0 });
  }
}

document.addEventListener('liquid-ajax-cart:request-end', function(event) {
  const settings = window.themeVariables?.settings;
  if (!settings?.freeGiftEnabled || !settings?.freeGiftVariantId) return;

  // Client-side time window check (supplements Liquid check for long-open pages)
  // Input format: DD-MM-YYYY HH:MM → convert to ISO for Date parsing
  function parseDDMMYYYY(str) {
    const [datePart, timePart] = str.split(' ');
    const [dd, mm, yyyy] = datePart.split('-');
    return new Date(`${yyyy}-${mm}-${dd}T${timePart || '00:00'}`);
  }
  const now = new Date();
  if (settings.freeGiftStartDate) {
    const start = parseDDMMYYYY(settings.freeGiftStartDate);
    if (now < start) return removeGiftIfPresent();
  }
  if (settings.freeGiftEndDate) {
    const end = parseDDMMYYYY(settings.freeGiftEndDate);
    if (now > end) return removeGiftIfPresent();
  }

  // Section HTML is already updated when request-end fires
  const qualifiesEl = document.getElementById('free-gift-qualifies');
  if (!qualifiesEl) return;

  const qualifies = qualifiesEl.value === 'true';
  const cart = window.liquidAjaxCart?.cart;
  if (!cart || !Array.isArray(cart.items)) return;

  const giftProp = '_free_gift';
  const giftVariantId = settings.freeGiftVariantId;

  const giftIndex = cart.items.findIndex(item =>
    item.properties?.[giftProp] === 'auto-added'
  );

  // Safety: if free gift is the only item in cart, remove it
  if (giftIndex > -1 && cart.items.length === 1) {
    window.liquidAjaxCart.change({ line: 1, quantity: 0 });
    return;
  }

  if (qualifies && giftIndex === -1) {
    // Don't re-add if user manually dismissed the gift this session
    if (sessionStorage.getItem('free_gift_dismissed')) return;
    // Conditions met, gift not in cart → add it
    window.liquidAjaxCart.add({
      items: [{
        id: giftVariantId,
        quantity: 1,
        properties: { [giftProp]: 'auto-added' }
      }]
    });
  } else if (!qualifies && giftIndex > -1) {
    // Conditions not met, gift in cart → remove it
    window.liquidAjaxCart.change({
      line: giftIndex + 1,
      quantity: 0
    });
  } else if (!qualifies && giftIndex === -1) {
    // Conditions no longer met and gift gone — clear dismiss flag so it can re-trigger next time
    sessionStorage.removeItem('free_gift_dismissed');
  }
});


// --- Free Shipping Shadow Product Mutation ---
// Registered as a liquidAjaxCart mutation (not an event listener) so it runs
// inside the library's serialized cart-update flow. This guarantees exactly
// one shadow line, no races, even with concurrent add requests.
function freeShippingShadowMutation() {
  const shadowVariantId = window.themeVariables?.settings?.freeShippingShadowVariantId;
  if (!shadowVariantId) return;

  const cart = window.liquidAjaxCart?.cart;
  if (!cart || !Array.isArray(cart.items)) return;

  const shadowProp = '_free_shipping_shadow';
  const qualifyingIds = window.themeVariables?.settings?.freeShippingProductIds || [];

  const shadowLines = cart.items
    .map((item, idx) => ({ item, line: idx + 1 }))
    .filter(({ item }) =>
      String(item.variant_id) === String(shadowVariantId) &&
      item.properties?.[shadowProp] === 'auto-added'
    );

  const nonShadowItems = cart.items.filter(item =>
    !(String(item.variant_id) === String(shadowVariantId) &&
      item.properties?.[shadowProp] === 'auto-added')
  );

  const hasQualifying = qualifyingIds.length > 0 && nonShadowItems.some(item =>
    qualifyingIds.includes(item.product_id)
  );

  // Collapse duplicates: if more than one shadow line exists, remove extras.
  if (shadowLines.length > 1) {
    return {
      requests: shadowLines.slice(1).map(({ line }) => ({
        type: 'change',
        body: { line, quantity: 0 }
      }))
    };
  }

  // Shadow would be the only item (no real items left) → remove it.
  if (shadowLines.length === 1 && nonShadowItems.length === 0) {
    return {
      requests: [{ type: 'change', body: { line: shadowLines[0].line, quantity: 0 } }]
    };
  }

  // Qualifying product present, no shadow → add one.
  if (hasQualifying && shadowLines.length === 0) {
    return {
      requests: [{
        type: 'add',
        body: {
          items: [{
            id: shadowVariantId,
            quantity: 1,
            properties: { [shadowProp]: 'auto-added' }
          }]
        }
      }]
    };
  }

  // No qualifying product, shadow present → remove it.
  if (!hasQualifying && shadowLines.length === 1) {
    return {
      requests: [{ type: 'change', body: { line: shadowLines[0].line, quantity: 0 } }]
    };
  }

  // If a shadow line somehow has quantity > 1, force it back to 1.
  if (shadowLines.length === 1 && shadowLines[0].item.quantity > 1) {
    return {
      requests: [{
        type: 'change',
        body: { line: shadowLines[0].line, quantity: 1 }
      }]
    };
  }
}


/**
 * SHOPIFY DISCOUNT CODE AUTO-APPLY
 */

(function() {
  'use strict';

  const STORAGE_KEY = 'shopify_discount_applied';

  // 1. Safe Parameter Extraction
  const params = new URLSearchParams(window.location.search);
  let discountCode = params.get('discount');

  // If no discount code is present, stop immediately
  if (!discountCode) return;

  // 2. Normalization (e.g., "Welcome" -> "WELCOME")
  discountCode = discountCode.trim().toUpperCase();

  // 3. Re-application Guard (Prevents infinite loops)
  try {
    const appliedCode = sessionStorage.getItem(STORAGE_KEY);
    if (appliedCode === discountCode) {
      return; // Code already applied this session, exit silently
    }
  } catch (e) {
    // Ignore Safari private mode errors
  }

  // 4. Apply Discount via Background Fetch
  fetch(`/discount/${encodeURIComponent(discountCode)}`, { redirect: 'manual' })
    .then(response => {
      // 5. Response Validation
      // Shopify returns 303 or 302 for valid codes.
      // 'opaqueredirect' is a fallback for certain browser security modes.
      const isSuccess = response.status === 303 || response.status === 302 || response.type === 'opaqueredirect';
      
      if (isSuccess) {
        console.log(`Discount applied successfully: ${discountCode}`);
        try {
          // Mark as applied so we don't fetch again this session
          sessionStorage.setItem(STORAGE_KEY, discountCode);
        } catch (e) {}
      } else if (response.status === 404) {
        console.warn(`Invalid discount code: ${discountCode}`);
      }
    })
    .catch(error => {
      console.error('Network error applying discount:', error);
    });

})();